import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
   const queryClient = new QueryClient({
      defaultOptions: {
         queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes (renamed from cacheTime in v5)
            refetchOnWindowFocus: false, // Don't refetch when user returns to tab
            retry: 1, // Retry failed requests once
         },
      },
   });

   nuxtApp.vueApp.use(VueQueryPlugin, { queryClient });

   return {
      provide: {
         queryClient,
      },
   };
});
